import { render } from "./ImsiDetailsPopup.vue?vue&type=template&id=2cbef09c&scoped=true"
import script from "./ImsiDetailsPopup.vue?vue&type=script&lang=js"
export * from "./ImsiDetailsPopup.vue?vue&type=script&lang=js"

import "./ImsiDetailsPopup.vue?vue&type=style&index=0&id=2cbef09c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbef09c"]])

export default __exports__